import classes from './TwoColumnImageWebForm.module.scss';
import { useState } from 'react';
import Markdown from 'markdown-to-jsx';
import useForm from './useForm';
import PartnerFormRedirect from '../../organisms/formRedirect/PartnerFormRedirect';

export default function TwoColumnImageWebForm(props) {
    const { handleChange, handleButton, isDisabled, inputsErrors, onSuccess, form } = useForm(
        props.type
    );

    const {
        0: ComponentContentSiteImage,
        1: ComponentContentSiteCopy,
        2: name,
        3: email,
        4: company,
        5: subject,
        6: message,
        7: submit
    } = props;

    const subjectList = subject.list?.options;
    const defaultSelectValue = subjectList[0];
    const [selected] = useState(defaultSelectValue);

    return (
        <div className={classes.oTwoColumnImageWebform} id={`oPartnerForm`}>
            <div className={`${classes.oContactWrapper} container`}>
                <div className={`row`}>
                    <div className={`${classes.oColImage} col-12 col-md-6`}></div>

                    <div className={`${classes.oColForm} col-12 col-md-6`}>
                        <h3 className={`${classes.aTitle} fnt32`}>
                            {ComponentContentSiteCopy.title}
                        </h3>
                        {onSuccess ? (
                            <PartnerFormRedirect ticketId={onSuccess} />
                        ) : (
                            <form
                                onSubmit={(e) => {
                                    handleButton(e);
                                }}
                                className={classes.contactForm}
                            >
                                <Markdown className={`${classes.aCopy} fnt13f`}>
                                    {ComponentContentSiteCopy?.copy}
                                </Markdown>
                                <label className={classes.contactLabel}>
                                    {/* <span className={`fnt12f`}>
                                        {name.title} <span className={classes.aRequired}>*</span>
                                    </span> */}
                                    <input
                                        className={classes.contactInputs}
                                        type="text"
                                        name="name"
                                        pattern="[aA-zZ_ ]{0,100}"
                                        title="Please use only alphabets (a to z)."
                                        value={form.name}
                                        onChange={(e) => handleChange(e)}
                                        placeholder={name.placeholder}
                                    />
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.name && name.error_message}
                                    </div>
                                </label>
                                <label className={classes.contactLabel}>
                                    {/* <span className={`fnt12f`}>
                                        {email.title} <span className={classes.aRequired}>*</span>
                                    </span> */}
                                    <input
                                        className={classes.contactInputs}
                                        type="email"
                                        name="email"
                                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,9}$"
                                        title="Invalid email"
                                        value={form.email}
                                        onChange={(e) => handleChange(e)}
                                        placeholder={email.placeholder}
                                    />
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.email && email.error_message}
                                    </div>
                                </label>
                                <label className={classes.contactLabel}>
                                    {/* <span className={`fnt12f`}>
                                        {company.title} <span className={classes.aRequired}>*</span>
                                    </span> */}
                                    <input
                                        className={classes.contactInputs}
                                        type="text"
                                        name="company"
                                        pattern="[aA-zZ_ ]{0,100}"
                                        title="Please use only alphabets (a to z)."
                                        value={form.company}
                                        onChange={(e) => handleChange(e)}
                                        placeholder={company.placeholder}
                                    />
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.company && company.error_message}
                                    </div>
                                </label>
                                <label className={classes.contactLabel}>
                                    {/* <span className={`fnt12f`}>
                                        {subject.title}
                                        <span className={classes.aRequired}>*</span>
                                    </span> */}
                                    <select
                                        className={classes.contactInputs}
                                        id="subjectSelect"
                                        name="subject"
                                        defaultValue={selected}
                                        style={{
                                            color:
                                                selected === defaultSelectValue ? 'gray' : 'black'
                                        }}
                                        onChange={(e) => handleChange(e)}
                                    >
                                        {subjectList.map((item) => (
                                            <option key={item} value={item}>
                                                {item}
                                            </option>
                                        ))}
                                    </select>
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.subject && subject.error_message}
                                    </div>
                                </label>
                                <label className={classes.contactLabel}>
                                    {/* <span className={`fnt12f`}>
                                        {message.title} <span className={classes.aRequired}>*</span>
                                    </span> */}
                                    <textarea
                                        className={classes.contactTextArea}
                                        name="message"
                                        value={form.message}
                                        onChange={(e) => handleChange(e)}
                                        placeholder={message.placeholder}
                                    />
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.message && message.error_message}
                                    </div>
                                </label>
                                <div
                                    className={`${classes.oCtaWrapper} ${
                                        classes[`${isDisabled && 'hideButton'}`]
                                    }`}
                                >
                                    <span
                                        className={`${classes.mBtn} ${
                                            classes[`${isDisabled && 'hideButton'}`]
                                        } ${classes.iconButton}`}
                                    >
                                        <figure className={classes.mIcon}>
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M2.66634 7.99976H13.333"
                                                    stroke="white"
                                                    strokeWidth="0.976562"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M8.00016 13.3334L13.3335 8.00008L8.00016 2.66675"
                                                    stroke="white"
                                                    strokeWidth="0.976562"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </figure>
                                        <span className={`${classes.aText} fnt18f`}>
                                            {submit.label}
                                        </span>
                                        <input
                                            type="submit"
                                            value={submit.label}
                                            className={classes.inputClick}
                                            disabled={isDisabled}
                                        />
                                    </span>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
            <div
                className={`${classes.oBackgroundImage}`}
                style={{
                    backgroundImage: `url(${ComponentContentSiteImage.image.data.attributes.url})`
                }}
            ></div>
        </div>
    );
}
